import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import "./scss/style.scss";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";

import React, {Suspense} from "react";
import {BrowserRouter, HashRouter, Route, Routes} from "react-router-dom";
import {Provider} from "react-redux";
import DefaultLayout from "./layout/DefaultLayout";
import Login from "./views/pages/login/Login";
import store from "./redux-store/store";
import SaleBillDetail from "./views/pages/sale/status/detail/SaleBillDetail";
import PopupSaleSt from "./views/pages/sale/status/detail/PopupSaleSt";
import PopupProductForm from "./views/pages/product/PopupProductForm";
import PopupKitchenPrtForm from "./views/pages/store/kitchen/PopupKitchenPrtForm";
import PopupCardApprDetail from "./views/pages/sale/report/appr/PopupCardApprDetail";
import PopupCardCompanyApprDetail from "./views/pages/sale/report/appr/PopupCardCompanyApprDetail";
import PopupCashApprDetail from "./views/pages/sale/report/appr/PopupCashApprDetail";
import PopupSaleRegister from "./views/pages/sale/manual/PopupSaleRegister";
import PopupStockDetail from "./views/pages/stock/PopupStockDetail"; //재고


const loading = (
    <div className={"pt-3 text-center"}>
        <div className={"sk-spinner sk-spinner-pulse"}/>
    </div>
);

function App() {
    console.log("###### App Init ######");
    return (
        <Provider store={store}>
            <HashRouter>
                <Suspense fallback={loading}>
                    <Routes>
                        <Route path={"/"} name={"Check"} element={<Login/>}/>
                        <Route exact path="/login" name="Login Page" element={<Login/>}/>
                        <Route exact path="/register" name="Register Page" element={<Login/>}/>
                        <Route exact path="/404" name="Page 404" element={<Login/>}/>
                        <Route exact path="/500" name="Page 500" element={<Login/>}/>
                        <Route exact path="/sale/detail" element={<SaleBillDetail/>}/>
                        <Route exact path="/product/PopupProductForm" element={<PopupProductForm/>}/>
                        <Route exact path="/*" name="Dashboard" element={<DefaultLayout/>}/>
                        <Route exact path="/**/*" name="Dashboard" element={<DefaultLayout/>}/>
                        <Route exact path="/sale/detail/pay" element={<PopupSaleSt/>}/>
                        <Route exact path="/store/kitchen/PopupKitchenPrtForm" element={<PopupKitchenPrtForm/>}/>
                        <Route exact path="/sale/appr/card" element={<PopupCardApprDetail/>}/>
                        <Route exact path="/sale/appr/cardCompany" element={<PopupCardCompanyApprDetail/>}/>
                        <Route exact path="/sale/appr/cash" element={<PopupCashApprDetail/>}/>
                        <Route exact path="/sale/manual/reg" element={<PopupSaleRegister />}/>
                        <Route exact path="/stock/detail" element={<PopupStockDetail />}/>
                    </Routes>
                </Suspense>
            </HashRouter>
        </Provider>
    );
}

export default App;
